import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#202020",
      d: "m8 0 4.619 4.619-1.238 1.237L8.875 3.35v7.887h-1.75V3.35L4.619 5.856 3.38 4.62z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#202020",
      d: "M0 10.237v2c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.093c.535.272 1.235.272 2.635.272h8c1.4 0 2.1 0 2.635-.272a2.5 2.5 0 0 0 1.092-1.093c.273-.534.273-1.234.273-2.635v-2h-1.75v2c0 .73-.001 1.17-.028 1.5-.037.448-.216.68-.723.722-.329.027-.77.028-1.499.028H4c-.729 0-1.17 0-1.5-.028-.494-.04-.685-.273-.722-.722-.027-.33-.028-.77-.028-1.5v-2z"
    }, null, -1)
  ]))]))
}
export default { render: render }